module.exports = __webpack_public_path__ + "img/fe79237ab209bf72479d0dec5ef45132.0a0d4f5b.png";